// ReposPage.tsx — landing page. Lists all registered repos as link cards.
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { unwrapJson } from 'common';
import { apiClient } from '../api';
import type { Repo } from '../api';

export default function ReposPage() {
  const [repos, setRepos] = useState<Repo[]>([]);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const res = await apiClient.fetch('/api/v1/repos');
        const data = await unwrapJson<{ repos: Repo[] }>(res);
        setRepos(data.repos ?? []);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'Failed to load repos');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <main>
      <h1>Repositories</h1>
      <p style={{ opacity: 0.7 }}>
        Each repo collects per-commit metric values pushed by your CI. Pick a repo to
        see its commits, metrics, and graphs. Admins register new repos under the{' '}
        <Link to="/admin">Admin</Link> tab.
      </p>
      {error && <div className="alert alert-danger">{error}</div>}
      {loading ? (
        <div className="empty-state">Loading…</div>
      ) : repos.length === 0 ? (
        <div className="empty-state">
          No repos registered yet. An admin needs to add one before metrics can flow.
        </div>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Repository</th>
              <th>Registered</th>
            </tr>
          </thead>
          <tbody>
            {repos.map((r) => (
              <tr key={r.id}>
                <td>
                  <Link to={`/repos/${r.owner}/${r.name}`} style={{ fontWeight: 600 }}>
                    {r.owner}/{r.name}
                  </Link>
                </td>
                <td style={{ opacity: 0.7 }}>
                  {new Date(r.created_at).toLocaleDateString()}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </main>
  );
}
